import React from "react";
import { CirclePicker } from 'react-color';
import { Field } from "formik";

type ColorPickerProps = {
  name: string
};

const ColorPicker: React.FunctionComponent<ColorPickerProps> = ({name})  => {
  return (
    <Field name={name} id={name} type="string">
    {({ 
      // @ts-ignore
      field: { value }, form: { setFieldValue } }) => (
      <div>
        <div>
        <CirclePicker color={value ? value : ""} onChange={(color) => setFieldValue(name, color?.hex)}/>
        </div>
      </div>
    )}
    </Field>
  );
};

export default ColorPicker; 